import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksServicePayments(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		options
	)
}
function _getRegulationsStagesPlanWorksServicePaymentPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksServicePaymentPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksServicePayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
		options
	)
}

function _getRegulationsStagesPlanWorksServicePayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
		options
	)
}

function _patchRegulationsStagesPlanWorksServicePayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
		options
	)
}

function _putRegulationsStagesPlanWorksServicePayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
		options
	)
}

function _deleteRegulationsStagesPlanWorksServicePayment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]: _getRegulationsStagesPlanWorksServicePayments,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_PREVIEW]: _getRegulationsStagesPlanWorksServicePaymentPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_POPUP]: _getRegulationsStagesPlanWorksServicePaymentPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: _createRegulationsStagesPlanWorksServicePayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: _getRegulationsStagesPlanWorksServicePayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: _patchRegulationsStagesPlanWorksServicePayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: _putRegulationsStagesPlanWorksServicePayment,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT]: _deleteRegulationsStagesPlanWorksServicePayment,
}
